import React from 'react';

const BottomBackButton = ({ isFullScreen, setIsFullScreen }) => {
  if (!isFullScreen) {
    return null;
  }
  
  return (
    <div className="bottom-nav">
      <button 
        onClick={() => setIsFullScreen(false)}
        className="back-button"
      >
        Back
      </button>
    </div>
  );
};

export default BottomBackButton; 